import ManageSubscription from './ManageSubscription';

export default ManageSubscription;